import { guestVMsResponseDto } from '../dto/guestVMsResponseDto';
import { guestVMsResponseViewModel } from '../views/guestVMsResponseViewModel';
import { GuestVMsResponseTransformer } from '../transformers/GuestVMsResponseTransformer';

export class virtualGuestVMsResponseTransformer {
  public static from(guestVMsResponse: guestVMsResponseDto): guestVMsResponseViewModel {
    return <guestVMsResponseViewModel>{
      guestVMsTable: GuestVMsResponseTransformer.from(guestVMsResponse.guestVMTable),
      runningVMs: guestVMsResponse.runningVMCount
    };
  }
}
